import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";
import { InputCustom } from "../../components/UIElements/input-ui";

import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";
import { getUrlPathId } from "../../utils/url-id";
import { useNotificationService } from "../../components/notification";
import { UsersDataProps, UsersDummyData } from "../../interface/users";
import UsersDetailsContent from "../../components/users/UsersDetailsContent";
import { apiGetUser } from "../../api/users";
import { apiGetResource } from "../../api/access";
import PermissionsDetailsContent from "../../components/users/PermissionsDetailsContent";
import BackButton from "../../components/UIElements/BackButton";

const Permissions = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [state_data, setState_data] = useState({ permissions: [], module: [] });
  const [filter_data, setFilter_data] = useState({
    filter: "module",
    module: "",
  });

  useEffect(() => {
    const fields = { filter: filter_data, token };
    mutation.mutate(fields);
  }, [filter_data.filter, filter_data.module]);

  const mutation = useMutation({
    mutationFn: (fields: {
      token: string;
      filter: { filter: string; module: string };
    }) => apiGetResource(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        
        if (filter_data.module?.length > 1) {
          setState_data((prev) => ({ ...prev, module: data?.data?.data }));
        } else setState_data({ permissions: data?.data?.data, module: [] });
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
      showNotification("Fetch process failed", "error");
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
          <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Create Roles
            </Typography>
          </Stack>
        </Box>
      </Header>
      <PermissionsDetailsContent stateData={state_data} filterData={filter_data} setFilterData={setFilter_data} loading={mutation.isPending} />
    </>
  );
};

export default Permissions;
